import { businessContactInformation } from "../data/business";
import { clientContactInformation } from "../data/client";
import invoice from "../data/invoice";
import { combineResourceLists } from "./combineResourceLists";

const rate = 28;
const firstInvoiceNumber = 25;
//18th september 2023
const firstInvoiceDate = new Date(2023, 8, 18);

export function dataToInvoice(
  timeEntires,
  clients,
  projects,
  tags,
  resourceLists
) {
  if (!timeEntires || !clients || !projects || !tags || resourceLists == null) {
    return;
  }
  // if empty
  if (
    timeEntires.length === 0 ||
    clients.length === 0 ||
    projects.length === 0 ||
    tags.length === 0
    // resourceLists.length === 0
  ) {
    return;
  }
  let invoiceData = {};

  // loop throguh time entries
  timeEntires.map((timeEntryOverview) => {
    timeEntryOverview.time_entries.map((timeEntry) => {
      if (!timeEntryOverview.billable) {
        return;
      }
      let project = projects.find(
        (project) => project.id === timeEntryOverview.project_id
      );
      let client = clients.find((client) => client.id === project.cid);
      const dataSummarised = {
        client: client.name,
        project: project.name,
        // description: timeEntry.description,
        seconds: timeEntry.seconds,
      };

      // get the date as a  string
      const date = new Date(timeEntry.start);
      let dateString = date.toISOString().split("T")[0];

      // turn into 11 September
      const dateArray = dateString.split("-");
      const year = dateArray[0];
      let month = dateArray[1];
      let day = dateArray[2];

      // remove leading 0
      if (day[0] === "0") {
        day = day[1];
      }
      // turn month into word
      switch (month) {
        case "01":
          month = "January";
          break;
        case "02":
          month = "February";
          break;
        case "03":
          month = "March";
          break;
        case "04":
          month = "April";
          break;
        case "05":
          month = "May";
          break;
        case "06":
          month = "June";
          break;
        case "07":
          month = "July";
          break;
        case "08":
          month = "August";
          break;
        case "09":
          month = "September";
          break;
        case "10":
          month = "October";
          break;
        case "11":
          month = "November";
          break;
        case "12":
          month = "December";
          break;
        default:
          month = month;
          break;
      }

      const dateFormatted = `${day} ${month}`;
      dateString = dateFormatted;

      // if not in invoiceData, add it
      if (!invoiceData[dateString]) {
        invoiceData[dateString] = {
          date: dateString,
          seconds: timeEntry.seconds,
          description: "",
          rate: 28,
          amount: timeEntryOverview.billable_amount_in_cents / 100,
          data: [dataSummarised],
        };
      } else {
        // if in invoiceData, add to it
        invoiceData[dateString].seconds += timeEntry.seconds;
        invoiceData[dateString].amount +=
          timeEntryOverview.billable_amount_in_cents / 100;

        let invoiceDataData = invoiceData[dateString].data;

        // check if client is in invoiceData
        let clientIndex = invoiceDataData.findIndex(
          (data) => data.client === client.name
        );

        // if client is not in invoiceData, add it
        if (clientIndex === -1) {
          invoiceData[dateString].data.push(dataSummarised);
        } else {
          // if client is in invoiceData, add to it
          invoiceData[dateString].data[clientIndex].seconds +=
            timeEntry.seconds;
        }

        // invoiceData[dateString].data.push(dataSummarised);
      }
    });
  });

  // make the invoice period from the first and last date
  const dates = Object.keys(invoiceData);
  const firstDate = dates[0];
  const lastDate = dates[dates.length - 1];
  const invoicePeriod = `${firstDate} - ${lastDate}`;

  // combine resource lists
  // TODO only keep resourceLists that are inbetween the first and last date

  // let resourceListsByDate = [];
  // resourceLists.forEach((resourceList) => {
  //   let date = resourceList.timeDateCreated;
  //   console.log(date, firstDate, lastDate);
  //   if (date >= firstDate && date <= lastDate) {
  //     resourceListsByDate.push(resourceList);
  //   }
  // });

  // console.log(resourceListsByDate);

  // invoice number is the firstInvoiceNumber  + number of invoices since firstInvoiceDate
  let invoiceNumber = firstInvoiceNumber;
  const mondayDate = new Date(firstDate + "2023");

  // how many mondays have passed since firstInvoiceDate
  const numberOfMondaysPassed =
    (mondayDate - firstInvoiceDate) / (1000 * 60 * 60 * 24 * 7);

  // add that to the invoice number
  invoiceNumber += numberOfMondaysPassed;
  // round to integer
  invoiceNumber = Math.round(invoiceNumber);

  return {
    invoiceNumber: invoiceNumber,
    invoicePeriod: invoicePeriod,
    business: businessContactInformation,
    client: clientContactInformation,
    resourceLists: combineResourceLists(resourceLists),
    items: invoiceData,
  };
}
